import { useEffect } from "react"
import { ListItem, Text } from "@artprov/design-system"
import { useFacturaStore } from "@/common/zustand/factura.store"
import PropTypes from "prop-types";

export default function InfoProveedores({ data }) {
  const detalleFacturaProveedor = useFacturaStore((state) => state.setDetalleFacturaProveedor)
  
  const getItemsProveedores = () => {
    return [
      {
        title: 'Razón social',
        content: data.RAZON_SOCIAL,
      },
      {
        title: 'CUIT',
        content: data.AF_CUIT,
      },
      {
        title: 'Dirección',
        content: data.DIRECCION,
      },
      {
        title: 'Contacto',
        content: data.CONTACTO,
      },
    ];
  }
    useEffect(() => {
    if (data && Object.keys(data).length > 0) {
      detalleFacturaProveedor(data)      
    }
  }, [data, detalleFacturaProveedor])
  
  return (
    <div className="border border-gray-300 rounded p-6 bg-white">
      <Text variant="body1" className="mb-4 font-semibold text-tertiary-10">
        Información del proveedor
      </Text>
      <ListItem
        distance={150}
        classNameContainer= ''
        classNameTitle='mr-24'
        classNameContent='w-full sm:w-auto text-left'
        items={getItemsProveedores()} 
        />
    </div>
  );
}

InfoProveedores.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
};
